module.exports = __webpack_public_path__ + "img/reserved_catch.05bdc3af.jpg";